import React, { useEffect, useState } from "react";
import { BACKEND_URL } from "../../lib/api";
import { LoopVideo } from "./VideoTrim";

export const fileUrl = (p) => `${BACKEND_URL}/api/files/${p}`;
export const mediaSrc = (u) => (u && u.startsWith("/api/") ? `${BACKEND_URL}${u}` : u);

// Rotating banner of couple-uploaded photos and videos; falls back to the single cover image.
export function HeroSlides({ slides, cover, coverFocus }) {
  const list = slides?.length ? slides : [{ slide_id: "cover", type: "image", url: mediaSrc(cover), focus: coverFocus }];
  const [i, setI] = useState(0);
  useEffect(() => {
    if (list.length < 2) return undefined;
    const t = setTimeout(() => setI((x) => (x + 1) % list.length), list[i]?.type === "video" ? 12000 : 6000);
    return () => clearTimeout(t);
  }, [i, list.length]); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <div className="absolute inset-0" data-testid="hero-slides">
      {list.map((s, k) => {
        const src = s.url || fileUrl(s.path);
        const cls = `absolute inset-0 w-full h-full object-cover transition-opacity duration-1000 ${k === i ? "opacity-100" : "opacity-0"}`;
        return s.type === "video"
          ? <LoopVideo key={s.slide_id} src={src} trim={s.trim} className={cls} data-testid={`hero-slide-${k}`} />
          : <img key={s.slide_id} src={src} alt="" className={cls} style={{ objectPosition: `${s.focus?.x ?? 50}% ${s.focus?.y ?? 50}%` }} data-testid={`hero-slide-${k}`} />;
      })}
      {list.length > 1 && (
        <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10 flex gap-1.5">
          {list.map((s, k) => <button key={s.slide_id} onClick={() => setI(k)} aria-label={`Slide ${k + 1}`} className={`h-1.5 rounded-full transition-[width] ${k === i ? "w-8 bg-white" : "w-3 bg-white/50"}`} data-testid={`hero-dot-${k}`} />)}
        </div>
      )}
    </div>
  );
}
